import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=74108866&"
import script from "./claims.vue?vue&type=script&lang=js&"
export * from "./claims.vue?vue&type=script&lang=js&"
import style0 from "./claims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports